import React, { Fragment } from 'react';

import Link from '../../shared/components/hyperlink';
import IntelBadgeContainer from './badge-container';

import '../css/coming-soon.less';

const COMING_SOON_LINKS =
    [{
        name: 'Laptops',
        destination: '/slp/weekly-deals/laptops'
    }, {
        name: 'Desktops',
        destination: '/slp/weekly-deals/desktops'
    }, {
        name: 'Printers',
        destination: '/slp/weekly-deals/printers'
    }, {
        name: 'Monitors',
        destination: '/slp/weekly-deals/monitors'
    }, {
        name: 'Accessories',
        destination: '/slp/weekly-deals/accessories'
    }, {
        name: 'Business',
        destination: '/slp/weekly-smb-deals'
    }];

class ComingSoon extends React.Component {
    render() {
        const { comingSoonLinks, intelBadge } = this.props;

        return (
            <Fragment>
                {intelBadge ? <div className="intel-badge-container"><IntelBadgeContainer /></div> : null}
                <div className='shop-more-container'>
                    <h1>Shop Weekly Deals:</h1>
                    <div className='pg-list'>
                        {comingSoonLinks.map((link, i) => {
                            return (
                                <Link to={`${link.destination.toLowerCase()}`} className='pg-list-item' key={i}>
                                    <div className={`hp-icon ${link.name.toLowerCase().replace(' ', '-')}`}>
                                        <p>{link.name}</p>
                                    </div>
                                </Link>
                            );
                        })}
                    </div>
                </div>
            </Fragment>
        );
    }
}

ComingSoon.defaultProps = {
    comingSoonLinks: COMING_SOON_LINKS
};

export default ComingSoon;
